'use client';

import { useAction, useAtom } from '@reatom/npm-react';
import { useBack } from '@trwl/hooks/useBack';
import { Path } from '@trwl/shared/lib/router';
import { refreshTokenAction } from '@trwl/store/actions';
import { isAuthedAtom } from '@trwl/store/atoms';
import { usePathname, useRouter } from 'next/navigation';
import { PropsWithChildren, useEffect, useState } from 'react';

const isLoginPage = (pathname: string) => {
  return pathname.includes(Path.LOGIN) || pathname.includes(Path.REGISTRATION);
};

export const IsAuthProvider = ({
  children,
  redirectToLogin = true,
}: PropsWithChildren & { redirectToLogin?: boolean }) => {
  const back = useBack();
  const [loading, setLoading] = useState(true);
  const pathname = usePathname();
  const router = useRouter();
  const [isAuth] = useAtom(isAuthedAtom);
  const refreshToken = useAction(refreshTokenAction);

  const loginPage = isLoginPage(pathname);

  useEffect(() => {
    if (!isAuth) return;

    refreshToken();
    const intervalId = setInterval(refreshToken, 600000);

    return () => clearInterval(intervalId);
  }, [isAuth, refreshToken]);

  useEffect(() => {
    if (!router) return;
    if (!redirectToLogin && !isAuth) return;
    if (isAuth && loginPage) {
      back(Path.PROFILE);
    }
    if (!isAuth && !loginPage) {
      router.push(Path.LOGIN);
    }
    setLoading(false);
  }, [back, redirectToLogin, loginPage, router, isAuth, pathname, setLoading]);

  if (!redirectToLogin && !isAuth) return null;
  if (loading) return null;
  return <>{children}</>;
};
